export default __webpack_public_path__ + "static/media/background-video.9ea272aa.mp4";